import { TbPlugConnected } from 'react-icons/tb';
const IntegrationsIcon = () => <TbPlugConnected size={20} />;

export default IntegrationsIcon;
